import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppComponent} from './app.component';
import {SignInComponent} from './pages/sign-in/sign-in.component';
import {DownloadComponent} from './pages/download/download.component';
import {LinksComponent} from './pages/links/links.component';
import {AgreementComponent} from './pages/agreement/agreement.component';
import {CheckboxComponent} from './pages/parts/checkbox/checkbox.component';

import {PageManagementService} from './service/pager/page-management.service';
import {DialogService} from './service/dialog/dialog.service';
import {WindowService} from './service/window/window.service';
import {UserAgentService} from './service/utils/user-agent.service';
import {GoogleAnalyticsService} from './service/utils/google-analytics.service';

export const AppRoutes = [
  {path: '', component: SignInComponent},
  {path: 'download', component: DownloadComponent},
  {path: 'links', component: LinksComponent},
  {path: 'agreement', component: AgreementComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    DownloadComponent,
    LinksComponent,
    AgreementComponent,
    CheckboxComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes),
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [
    PageManagementService,
    DialogService,
    WindowService,
    UserAgentService,
    GoogleAnalyticsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/app.module.ts